import { isEqual } from 'lodash'
import { lazy, memo, Suspense, useState } from 'react'
import type { DisplayMode } from './Navigator/Navigator'
import type { StackedChartSection } from './types'

const LazyNavigator = lazy(() => import('./Navigator/Navigator').then((m) => ({ default: m.Navigator })))

const LazySectionsWrapper = lazy(() =>
  import('./SectionsWrapper/SectionsWrapper').then((m) => ({ default: m.SectionsWrapper })),
)

const StackedChart = ({
  childrenUpper,
  containerWidth,
  content,
  timezone,
  navigatorKey,
  navigatorDisplayMode,
  hasExtraRightPadding,
}: {
  childrenUpper?: React.ReactNode
  containerWidth: number
  content: StackedChartSection[]
  timezone: string
  navigatorKey: string | null
  navigatorDisplayMode?: DisplayMode
  hasExtraRightPadding?: boolean
}) => {
  const [stackedChartId] = useState(`StackedChart-${Math.random()}`)

  if (!content.length) return null

  return (
    <div>
      <Suspense fallback={null}>
        <LazyNavigator
          childrenUpper={childrenUpper}
          sections={content}
          stackedChartId={stackedChartId}
          timezone={timezone}
          key={navigatorKey}
          hasExtraRightPadding={hasExtraRightPadding}
          displayMode={navigatorDisplayMode}
        />
      </Suspense>
      <Suspense fallback={null}>
        <LazySectionsWrapper
          containerWidth={containerWidth}
          sections={content}
          stackedChartId={stackedChartId}
          timezone={timezone}
          hasExtraRightPadding={hasExtraRightPadding}
        />
      </Suspense>
    </div>
  )
}

const MemoizedStackedChart = memo(StackedChart, isEqual)

export { MemoizedStackedChart as StackedChart }
